var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.cruiseData),function(cruise,index){return _c('CruiseSlideCard',{key:index,ref:"cruiseSlideCard",refInFor:true,attrs:{"card-data":cruise,"cruise-index":index,"is-card-active":_vm.activeClass(index),"showTime":true,"text-labels":_vm.textLabels},on:{"click":function($event){return _vm.chooseCruise(index)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }